import React from 'react';

import { fieldProps } from '../../types';
import { getWidget, getUiOptions, optionsList, getDefaultRegistry } from '../../utils';

function BooleanField(props) {
  const {
    schema,
    name,
    uiSchema = {},
    idSchema,
    formData,
    registry = getDefaultRegistry(),
    required,
    disabled = false,
    readonly = false,
    autofocus = false,
    onChange,
    onFocus,
    onBlur,
  } = props;
  const { title } = schema;
  const { widgets, formContext, fields } = registry;
  const { widget = 'checkbox', ...options } = getUiOptions(uiSchema);
  const Widget = getWidget(schema, widget, widgets);
  const placeholder = schema.examples?.[0] ?? '';

  let enumOptions;

  if (Array.isArray(schema.oneOf)) {
    enumOptions = optionsList({
      oneOf: schema.oneOf.map(option => ({
        ...option,
        title: option.title || (option.const === true ? 'Yes' : 'No'),
      })),
    });
  } else {
    enumOptions = optionsList({
      enum: schema.enum || [true, false],
      enumNames: schema.enumNames || (schema.enum && schema.enum[0] === false ? ['No', 'Yes'] : ['Yes', 'No']),
    });
  }

  return (
    <Widget
      autofocus={autofocus}
      DescriptionField={fields.DescriptionField}
      disabled={disabled}
      formContext={formContext}
      id={!!idSchema && idSchema.$id}
      label={title === undefined ? name : title}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      options={{ ...options, enumOptions }}
      placeholder={placeholder}
      readonly={readonly}
      registry={registry}
      required={required}
      schema={schema}
      value={formData}
    />
  );
}

BooleanField.propTypes = fieldProps;

export default BooleanField;
